import _typeof from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/typeof";
import freeGlobal from './_freeGlobal.js';
/** Detect free variable `self`. */

var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobal || freeSelf || Function('return this')();
export default root;